<template>
  <vjs-modal v-bind="$options.propsData"
             title="Creating New Person"
             icon="la la-user">
    <template #body-content>
      <form>
        <div class="row">
          <!-- Left side -->
          <div class="col-12 col-sm-4">
            <display-with-selection-modal :preselected-artwork="person.artwork" @selected="(ev) => (person.artwork = ev.selected_artwork)">
              <template #label>
                <label class="mb-1"><strong>Artwork *</strong></label>
              </template>
            </display-with-selection-modal>
            <!-- spoof input for v-validate -->
            <input v-model="person.artwork"
                   v-validate="'required'"
                   data-vv-scope="create-person-form"
                   name="Person Artwork"
                   type="text"
                   class="d-none">
            <p v-show="errors.has('Person Artwork', 'create-person-form')" class="help text-ss-danger">
              {{ errors.first('Person Artwork', 'create-person-form') }}
            </p>
          </div>

          <!-- Right side -->
          <div class="col-12 col-sm-8">
            <div class="form-group mb-4">
              <label for="create_person_name">
                <strong>Name <em>*</em></strong>
              </label>
              <input id="create_person_name"
                     v-model="person.name"
                     v-validate="'required'"
                     data-vv-scope="create-person-form"
                     name="Person Name"
                     type="text"
                     class="form-control"
                     placeholder="John Doe">
              <p v-show="errors.has('Person Name', 'create-person-form')" class="help text-ss-danger">
                {{ errors.first('Person Name', 'create-person-form') }}
              </p>
            </div>
            <div class="form-group mb-4">
              <label><strong>Role <em>*</em></strong></label>
              <multiselect v-model="selected_taxonomy"
                           :options="taxonomy"
                           :multiple="false"
                           :allow-empty="false"
                           :custom-label="searchableLabel"
                           placeholder="Select Role"
                           :max-height="160"
                           @select="pushSelection" />
            </div>
            <div class="form-group">
              <label for="create_person_link"><strong>Link<span id="person_link_tooltip" class="ml-2 la la-question-circle" /></strong></label>
              <b-tooltip target="person_link_tooltip" triggers="hover">
                <div v-sanitise="tooltips.person_link_tooltip" />
              </b-tooltip>
              <input id="create_person_link"
                     v-model="person.link"
                     v-validate="{url: {require_protocol: true }, required: false}"
                     data-vv-scope="create-person-form"
                     name="Person Link"
                     type="text"
                     class="form-control"
                     placeholder="https://link-to-website/person">
              <p v-show="errors.has('Person Link', 'create-person-form')" class="help text-ss-danger">
                {{ errors.first('Person Link', 'create-person-form') }}
              </p>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template #body-controls>
      <b-button :disabled="!can_confirm" variant="ss-standout" @click="submitPerson">
        Confirm
      </b-button>
      <b-button variant="ss-cancel" @click="() => close(false)">
        Cancel
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import PersonModalMixin from "VueMixins/PersonModalMixin";
import TooltipsMixin from "VueMixins/TooltipsMixin";
import { mapActions, mapWritableState } from 'pinia';
import { usePeopleStore } from "VueStore/app/people";

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
VeeValidate.config.fieldsBagName = "veeFields";

export default {
  name: 'create_person_modal',
  mixins: [PersonModalMixin, TooltipsMixin],
  computed: {
    ...mapWritableState(usePeopleStore, ['taxonomy']),
    ...mapWritableState(usePeopleStore, ['selected_taxonomy']),
    ...mapWritableState(usePeopleStore, ['person']),
  },
  beforeMount() {
    this.reset();
  },
  methods: {
    ...mapActions(usePeopleStore, ['getAllPeople']),
    ...mapActions(usePeopleStore, ['setupPersonCreate']),
    submitPerson() {
      this.$validator.validateAll('create-person-form').then((result) => {
        this.person.artwork_uuid = this.person.artwork.uuid;
        if (result) {
          axios.post('/api/v1/people', this.person).then((response) => {
            toastr.success("New Person Created.");
            EventBus.$emit('new-person-created', response.data.data);
            this.reset();
            this.close();
          });
        } else {
          toastr.error("Some fields have not been populated correctly.");
        }
      });
    },
    reset() {
      this.setupPersonCreate();
    },
  },
};
</script>
